import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../ui-core/Button/Button';
import { Offer } from '../../../FullBodyMobility/components';

import './style.css';
// import { useNavigate } from 'react-router';
// import { LOCAL_STORAGE_CONSTANT } from '../../../../constants/app';
// import { extractJSON } from '../../../../services/jsonUtil';
// import { APP_ROUTES } from '../../../../route';

export const OfferWithButton = ({
  btnText,
  coupon,
  couponFirst,
  loading,
  mode,
  onClick,
  sectionTitle,
  text,
}) => {
  // const navigate = useNavigate();
  // const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);
  const handleClick = () => {
    if (onClick) {
      // if (session) {
      onClick(btnText, 'isSignup', sectionTitle);
      // } else {
      //   navigate(APP_ROUTES.SIGNUP_ONBOARDING);
      // }
    }
  };
  return (
    <div className="offers-box">
      <Offer
        coupon={coupon}
        couponFirst={couponFirst}
        mode={mode}
        text={text}
      />
      <Button
        class="sign-up-button-new"
        isDisabled={loading}
        isLoading={loading}
        onClick={handleClick}
        text={btnText}
      />
    </div>
  );
};

OfferWithButton.propTypes = {
  btnText: PropTypes.string.isRequired,
  coupon: PropTypes.string.isRequired,
  couponFirst: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.string,
  onClick: PropTypes.func,
  sectionTitle: PropTypes.string,
  text: PropTypes.string,
};
